import React from 'react';
import classNames from 'classnames';
import parse from 'html-react-parser';

interface Props {
  title?: React.ReactNode | string;
  subtitle?: string;
  className?: string;
}

const ContentHeader: React.FC<Props> = (props) => {
  const { title, subtitle, className } = props;

  return (
    <div className={classNames('flex flex-col gap-1', className)}>
      {title && (
        <div className="text-[1.75rem] sm:text-[2.5rem] font-medium leading-tight">
          {title}
        </div>
      )}

      {subtitle && <div>{parse(subtitle)}</div>}
    </div>
  );
};

export default ContentHeader;
